"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _FiatDepositModalComponent = _interopRequireDefault(require("./FiatDepositModalComponent"));
var _modalDecorator = _interopRequireDefault(require("../../../../hocs/modalDecorator"));
var _modalActions = require("../../../../redux/actions/modalActions");
var _depositActions = require("../../../../redux/actions/depositActions");
var _config = _interopRequireDefault(require("../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var bankInfo = {};
  if (ownProps.payload && _config["default"].Deposit[ownProps.payload.ProductSymbol]) {
    var depositBankInfo = _config["default"].Deposit[ownProps.payload.ProductSymbol];
    bankInfo = {
      name: depositBankInfo.bankName,
      wireNumber: depositBankInfo.bankWireNumber,
      accountNumber: depositBankInfo.bankAccountNumber
    };
  }
  return {
    bankInfo: bankInfo,
    showDepositIdModal: _config["default"].Deposit.showDepositIdModal
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    submitDeposit: function submitDeposit(payload) {
      return dispatch((0, _depositActions.createDepositTicket)(payload));
    },
    openReferenceModal: function openReferenceModal() {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.DEPOSIT_REFERENCE_ID, {
        ProductSymbol: ownProps.payload.ProductSymbol
      }));
    }
  };
};
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FiatDepositModalComponent["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.CONFIRM_FIAT_DEPOSIT
})(container);